module.exports = __webpack_public_path__ + "img/albnismo.cd854ba7.webp";